import axios from "axios";
import { Convenio } from "../models/convenio";
import { PagedResult } from "../models/paged-result";
import { ReemplazoConfirmado } from "../models/practica-conflicto";
import { UploadConvenio } from "../models/upload-convenio";

export interface ConfirmarConvenioResponse {
  id: string;
  active: boolean;
  practicasReasignadas: number;
}

export const CONVENIO_URL = `Convenio`;

export const convenioServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${CONVENIO_URL}`, { params: queryParams });
  },
  getById: (id: string) => {
    return axios.get<any>(`${CONVENIO_URL}/${id}`);
  },
  // Edición de los datos básicos del convenio (no toca prácticas/precios)
  update: function (id: string, data: any) {
    return axios.put<Convenio>(`${CONVENIO_URL}/${id}`, data);
  },
  // Carga de convenio (borrador) a partir de un Excel de prácticas/precios
  upload: function (formData: FormData) {
    return axios.post<UploadConvenio>(`${CONVENIO_URL}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  confirmar: function (id: string, reemplazos?: ReemplazoConfirmado[]) {
    return axios.post<ConfirmarConvenioResponse>(
      `${CONVENIO_URL}/${id}/confirmar`,
      reemplazos && reemplazos.length > 0 ? { reemplazos } : {}
    );
  },
  anular: function (id: string) {
    return axios.post(`${CONVENIO_URL}/${id}/anular`);
  },
  getPracticasByOs: (
    obraSocialId: string,
    fecha: any,
    profesionalId: string,
    codigoPractica?: string
  ) => {
    let params = `id=${obraSocialId}&fecha=${fecha}&profesionalId=${profesionalId}`;
    if (codigoPractica) params = params + `&codigoPractica=${codigoPractica}`;
    return axios.get<any>(
      `${CONVENIO_URL}/GetPracticasByObraSocialIdAndDate?${params}`
    );
  },
  getPracticasList: (convenioId: string, queryParams: any) => {
    return axios.get<PagedResult>(`${CONVENIO_URL}/practicas-convenio-list/${convenioId}`, { params: queryParams });
  },
  // Edición de una práctica/precio puntual dentro de un convenio
  updatePractica: function (convenioPracticaPrecioId: string, data: any) {
    return axios.put(`${CONVENIO_URL}/practica-convenio-precio/${convenioPracticaPrecioId}`, data);
  },
};
